import {
	customCartByID,
	customCartCreate,
	customCartDestroy,
	customCartList,
	customCartListInside,
	customCartUpdate,
} from '@/services/customCarts.service'

export default {
	namespaced: true,
	state: {
		// CUSTOM CARTS
		customCartList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		customCartListInside: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		customCart: {},
		// STATUS CUSTOM CARTS
		customCartStatus: 'pending',
		customCartSaveStatus: 'init',
		customCartDeleteStatus: 'init',
	},
	getters: {
		// CUSTOM CARTS
		getCustomCartList(state) {
			return state.customCartList
		},
		getCustomCartListInside(state) {
			return state.customCartListInside
		},
		getCustomCart(state) {
			return state.customCart
		},
		// CUSTOM CARTS STATUS
		getCustomCartDeleteStatus(state) {
			return state.customCartDeleteStatus
		},
		getCustomCartSaveStatus(state) {
			return state.customCartSaveStatus
		},
		getCustomCartStatus(state) {
			return state.customCartStatus
		},
	},
	mutations: {
		// CUSTOM CARTS
		CUSTOM_CART_LIST(state, value) {
			state.customCartList = value
		},
		CUSTOM_CART_LIST_INSIDE(state, value) {
			state.customCartListInside = value
		},
		SET_CUSTOM_CART(state, value) {
			state.customCart = value
		},
		// CUSTOM CARTS STATUS
		CUSTOM_CART_STATUS(state, value) {
			state.customCartStatus = value
		},
		CUSTOM_CART_SAVE_STATUS(state, value) {
			state.customCartSaveStatus = value
		},
		CUSTOM_CART_DELETE_STATUS(state, value) {
			state.customCartDeleteStatus = value
		},
	},
	actions: {
		// CUSTOM CARTS
		async fetchCustomCartList({ commit }, params) {
			commit('CUSTOM_CART_STATUS', 'pending')
			commit('CUSTOM_CART_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await customCartList(params)
				commit('CUSTOM_CART_STATUS', 'init')
				commit('CUSTOM_CART_LIST', data)
				return data
			} catch (error) {
				commit('CUSTOM_CART_STATUS', 'init')
				throw error
			}
		},
		async fetchCustomCartListInside({ commit }, params) {
			commit('CUSTOM_CART_STATUS', 'pending')
			commit('CUSTOM_CART_LIST_INSIDE', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await customCartListInside(params)
				commit('CUSTOM_CART_STATUS', 'init')
				commit('CUSTOM_CART_LIST_INSIDE', data)
				return data
			} catch (error) {
				commit('CUSTOM_CART_STATUS', 'init')
				throw error
			}
		},
		async fetchCustomCartByID({ commit }, params) {
			commit('CUSTOM_CART_STATUS', 'pending')
			try {
				const { data } = await customCartByID(params)
				commit('CUSTOM_CART_STATUS', 'init')
				commit('SET_CUSTOM_CART', data.data)
				return data.data
			} catch (error) {
				commit('CUSTOM_CART_STATUS', 'init')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
		async saveNewCustomCart({ commit }, params) {
			commit('CUSTOM_CART_SAVE_STATUS', 'pending')
			try {
				const { data } = await customCartCreate(params)
				commit('CUSTOM_CART_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CUSTOM_CART_SAVE_STATUS', 'init')
				throw error
			}
		},

		async updateCustomCart({ commit }, params) {
			commit('CUSTOM_CART_SAVE_STATUS', 'pending')
			try {
				const { data } = await customCartUpdate(params)
				commit('CUSTOM_CART_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CUSTOM_CART_SAVE_STATUS', 'init')
				throw error
			}
		},

		async deleteCustomCartByID({ commit }, params) {
			commit('CUSTOM_CART_DELETE_STATUS', 'pending')
			try {
				const { data } = await customCartDestroy(params)
				commit('CUSTOM_CART_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('CUSTOM_CART_DELETE_STATUS', 'error')
				this._vm.$root.$notify({
					message: error.response.data.message,
					type: 'danger',
				})
				return error
			}
		},
	},
}
